// Module
var code = "<h1 id=\"sports-houses\">Sports Houses</h1> <p>This section is for basic sports house creation.</p> <p>A sports house gets assigned to a student in the Sports Houses tab of their profile.</p> ";
// Exports
module.exports = code;